export const baseUrl = 'https://staging.trmsdr.com'
export const baseReportUrl = 'https://staging.trmsdr.com'
